import React from "react";
import "../styles/pages/privacypolicy.css";
import SubHome from "../components/SubHome";

const CookerOnCheffy = () => {
  return (
    <>
      <SubHome mainHeading="Cooker en Cheffy" listItem="Cooker en Cheffy" />
      <div className="privacy-policy-container">
        <div
          className="heading-content-section"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h2 className="main-heading">Cómo Convertirte en Cooker en Cheffy</h2>
          <div
            className="heading-border"
            style={{ marginBottom: "40px" }}
          ></div>
        </div>

        <p>
        ¿Listo para compartir tu talento culinario y ganar dinero cocinando para otros? Convertirte en Cooker en Cheffy es fácil, seguro y puedes comenzar en unos pocos pasos simples. Así es cómo:
        </p>

        <ol>
          <li>
            <h4>Regístrate y Verifica Tu Identidad: </h4>
            <p>
            Para garantizar una experiencia segura y confiable para todos nuestros usuarios, requerimos que los Cookers proporcionen una identificación personal, como un DNI o licencia de conducir. Este paso ayuda a mantener nuestra comunidad segura.
            </p>
          </li>
          <li>
            <h4>Agrega Tu Cuenta Bancaria:</h4>
            <p>
            Para que recibas tus pagos de forma fluida, simplemente vincula tu cuenta bancaria, y todas las ganancias de tus servicios serán transferidas directamente a ti. Este sistema seguro garantiza que recibirás tu pago de manera confiable por cada comida que cocines.
            </p>
          </li>
          <li>
            <h4>¡Comienza a Cocinar!:</h4>
            <p>
            Una vez que tu perfil esté completo, ¡ya estás listo para comenzar! Explora las ofertas de los Eaters, elige las que se ajusten a tu estilo culinario y comienza a cocinar deliciosas comidas que a la gente le encantarán.
            </p>
          </li>
        </ol>

        <p>
        Convertirte en Cooker con Cheffy es así de simple: abre una cuenta, configura tu perfil y comienza a compartir tus habilidades culinarias con nuevos clientes mientras ganas dinero.
        </p>
      </div>
    </>
  );
};

export default CookerOnCheffy;
